import {accessKeyId, secretAccessKey} from "./awsCredentials"

export const awsCommentFileUploadConfig: any = {
  bucketName: process.env.REACT_APP_BUCKET_COMMENT_FILE_ATTACHMENT,
  region: process.env.REACT_APP_REGION,
  accessKeyId,
  secretAccessKey,
  s3Url: 'https://b4igo-comments-attachments.s3.amazonaws.com',
}
